const page = r => require.ensure([], () => r(require('../components/editor/page/Index.vue')), 'page');
const editor = r => require.ensure([], () => r(require('../components/editor/Index.vue')), 'editor');
const apps = r => require.ensure([], () => r(require('../components/apps/Index.vue')), 'apps');
const appSetting = r => require.ensure([], () => r(require('../components/apps/AppSetting.vue')), 'appSetting');
const projects = r => require.ensure([], () => r(require('../components/projects/Index.vue')), 'projects');
const projectManage = r => require.ensure([], () => r(require('../components/projects/ProjectManage.vue')), 'projectManage');
const emailSetting = r => require.ensure([], () => r(require('../components/projects/EmailSetting.vue')), 'emailSetting');
const phoneMsgSetting = r => require.ensure([], () => r(require('../components/projects/PhoneMsgSetting.vue')), 'phoneMsgSetting');
const dbSetting = r => require.ensure([], () => r(require('../components/projects/DbSetting.vue')), 'dbSetting');
const dbQuery = r => require.ensure([], () => r(require('../components/projects/DbQuery.vue')), 'dbQuery');
const ossSetting = r => require.ensure([], () => r(require('../components/projects/OssSetting.vue')), 'ossSetting');
const redisSetting = r => require.ensure([], () => r(require('../components/projects/RedisSetting.vue')), 'redisSetting');
const PrivatizationDeploy = r => require.ensure([], () => r(require('../components/projects/PrivatizationDeploySetting.vue')), 'PrivatizationDeploy');
const login = r => require.ensure([], () => r(require('../components/login/Login.vue')), 'login');
const register = r => require.ensure([], () => r(require('../components/login/Register.vue')), 'register');
const forget_password = r => require.ensure([], () => r(require('../components/login/ForgetPassword.vue')), 'forget_password');
const error = r => require.ensure([], () => r(require('../components/Error.vue')), 'error');
const index = r => require.ensure([], () => r(require('../components/homepage/Index.vue')), 'index');
const usercenter = r => require.ensure([], () => r(require('../components/usercenter/Index.vue')), 'usercenter');
const discuss = r => require.ensure([], () => r(require('../components/discuss/Index.vue')), 'discuss');
const market = r => require.ensure([], () => r(require('../components/market/Index.vue')), 'market');
const management = r => require.ensure([], () => r(require('../components/management/Index.vue')), 'management');
const pluginsManage = r => require.ensure([], () => r(require('../components/projects/PluginsManage.vue')), 'pluginsManage');
const securitySetting = r => require.ensure([], () => r(require('../components/projects/SecuritySetting.vue')), 'securitySetting');
const deployedApp = r => require.ensure([], () => r(require('../components/projects/DeployedApp.vue')), 'deployedApp');
// 流程图编辑界面
const flow = r => require.ensure([], () => r(require('../components/flow/Index.vue')), 'flow');
const releaseLog = r => require.ensure([], () => r(require('../components/common/dialog/releaseLog.vue')), 'releaseLog');

// 三方插件接口开发界面
const develop = r => require.ensure([], () => r(require('../components/develop/Index.vue')), 'develop');
const interfaceManage = r => require.ensure([], () => r(require('../components/develop/Interface.vue')), 'interface');
const control = r => require.ensure([], () => r(require('../components/control/index.vue')), 'control');
const controlComponentList = r => require.ensure([], () => r(require('../components/control/component/listTabs.vue')), 'controlComponentList');
const controlComponent = r => require.ensure([], () => r(require('../components/control/component/item.vue')), 'controlComponent');

// 应用信息配置界面
const configSetting = r => require.ensure([], () => r(require('../components/develop/setting/Index.vue')), 'configSetting');
const helpInfo = r => require.ensure([], () => r(require('../components/help/ManageHelp.vue')), 'helpInfo')
export default {
  '/': {
    component: index,
    name: 'index'
  },

  '/control': {
    component: control,
    name: 'control',
    login: true
  },

  '/management': {
    component: management,
    name: 'management',
    login: true,

    subRoutes: {
      '/user_center': {
        component: usercenter,
        name: 'usercenter',
        login: true
      },

      '/develop/service/:service_id': {
        component: develop,
        name: 'develop',
        login: true
      },

      '/develop/service/list/:service_id': {
        component: interfaceManage,
        name: 'interface',
        login: true
      },

      '/market': {
        component: market,
        name: 'market',
        login: true
      },
      '/discuss': {
        component: discuss,
        name: 'discuss',
        login: true
      },

      '/setting/:project_id/:app_id/:service_id': {
        component: configSetting,
        name: 'configSetting',
        login: true
      },


      '/control': {
        component: control,
        name: 'control',
        login: true
      },

      '/control/components': {
        component: controlComponentList,
        name: 'controlComponentList',
        login: true
      },
      '/control/components/:component_id': {
        component: controlComponent,
        name: 'controlComponent',
        login: true
      },

      '/apps/:project_id/:app_id': {
        name: 'appSetting',
        component: appSetting,
        login: true,
      },

      '/project/:project_id': {
        name: 'projectManage',
        component: projectManage,
        login: true,

        subRoutes: {
          '/apps': {
            name: 'apps',
            component: apps,
            login: true,
          },

          '/email': {
            name: 'emailSetting',
            component: emailSetting,
            login: true,
          },

          '/phone_msg': {
            name: 'phoneMsgSetting',
            component: phoneMsgSetting,
            login: true,
          },

          '/db_setting': {
            name: 'dbSetting',
            component: dbSetting,
            login: true,
          },

          '/db_query': {
            name: 'dbQuery',
            component: dbQuery,
            login: true,
          },

          '/redis_setting': {
            name: 'redisSetting',
            component: redisSetting,
            login: true,
          },

          '/oss_setting': {
            name: 'ossSetting',
            component: ossSetting,
            login: true,
          },

          '/private_deploy': {
            name: 'privatizationDeploy',
            component: PrivatizationDeploy,
            login: true,
          },

          '/plugins_manage': {
            name: 'pluginsManage',
            component: pluginsManage,
            login: true,
          },

          '/security_setting': {
            name: 'securitySetting',
            component: securitySetting,
            login: true,
          },

          '/deployed_app': {
            name: 'deployedApp',
            component: deployedApp,
            login: true,
          }
        }
      },

      '/projects': {
        name: 'projects',
        component: projects,
        login: true
      },
    }
  },

  '/editor': {
    component: editor,
    subRoutes: {
      '/:app_id/panel/': {
        name: 'panel',
        component: page,
        login: true
      },

      '/:app_id/panel/:page_id': {
        name: 'panel',
        component: page,
        login: true
      },

      '/:app_id/flow/': {
        name: 'flow',
        component: flow,
        login: true
      },

      // '/:app_id/flow/:page_id': {
      //   name: 'flow',
      //   component: flow,
      //   login: true
      // },
      // 切换流程图时更改路由会卡
      '/:app_id/flow/:page_id/flow_id/:flow_id': {
        name: 'flow',
        component: flow,
        login: true
      },
    }
  },

  // '/apps': {
  //   name: 'apps',
  //   component: apps,
  //   login: true
  // },

  '/login': {
    name: 'login',
    component: login
  },

  '/register': {
    name: 'register',
    component: register
  },

  '/forget_password': {
    name: 'forget_password',
    component: forget_password
  },

  '/error': {
    name: 'error',
    component: error
  },

  '/iview/radio': {
    name: 'radio',
    component: r => require.ensure([], () => r(require('../components/iview/radio.vue')))
  },

  '/iview/table': {
    name: 'table',
    component: r => require.ensure([], () => r(require('../components/iview/table.vue')))
  },

  '/release_log': {
    name: 'releaseLog',
    component: releaseLog,
  },
  '/help': {
    name: 'help',
    component: helpInfo,
    login: true
  }
}



// WEBPACK FOOTER //
// ./src/router/map.js